export enum CouponsTab {
  DISCOUNT = 'Discount',
  COUPONS = 'Coupons'
}
